define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/usersWithProfilesGridView.tmpl");
    var UsersGridRowView = require("user-management-views/users/UsersWithProfilesGridRowView");
    var UserListFootnoteView = require("user-management-views/users/UserListFootnoteView");
    var UsersGridEmptyView = require("user-management-views/users/UsersGridEmptyView");
    var Checkbox = require("ui/checkbox/Checkbox");
    var Loader = require("ui/loader/Loader");

    var UsersGridView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UsersGridView = Marionette.GridView.extend({
            className: "table-main ui-table",
            template: template,
            itemViewContainer: "tbody",
            itemView: UsersGridRowView,
            emptyView: UsersGridEmptyView,
            withUIComponents: true,
            ui: {
                selectAll: ".header .selector .wrap",
                footnoteContainer: ".footnote-container",
                footnoteLoaderContainer: ".footnote-loader-container",
                groups: ".groups",
                userType: ".user-type",
                lobs: ".lobs"
            },
            uiComponents: {
                loader: {
                    type: Loader,
                    options: {
                        el: "view.ui.footnoteLoaderContainer",
                        permutation: Loader.PERMUTATION.H
                    }
                }
            },
            initialize : function (options) {
                LEUserManagement.logger.debug("onRender", "UsersWithProfilesGridView:onRender");
                this.selectableCollection = options.selectableCollection;
                this.settingsCollection = options.settingsCollection;
                this.listenTo(this.settingsCollection,"fetch:success",this._displayFootNote);
                this.listenTo(this.settingsCollection,"fetch:error",this._displayFootNote);
                this.groupColumnVisible = false; //init to false we accept this in a setter function, so its redundent to get by options
                this.userTypeColumnVisible = false;
                this.lobsColumnVisible = false;
            },

            clearSelection: function () {
                this.selectableCollection.clearSelection();
                this._checkAllItems(false, true);
                this.updateCheckAll();
            },

            onRender: function() {
                LEUserManagement.logger.debug("onRender", "UsersWithProfilesGridView:onRender");
                this._displayGroupsColumn();
                this._displayUserTypeColumn();
                this._displayLobsColumn();
                this._createCheckAll();
                this._displayFootNote();
            },

            onCompositeCollectionRendered:function(){
                LEUserManagement.logger.debug("onCompositeCollectionRendered enter", "UsersWithProfilesGridView:onCompositeCollectionRendered");
                _.each(this.collection.getSelected(), function(selectedModel){
                    if (!_.isEmpty(this.children.findByModel(selectedModel))) {
                        selectedModel.trigger("model:selection:change", true);
                    }
                }, this);
                this.updateCheckAll();
                LEUserManagement.logger.debug("onCompositeCollectionRendered exit", "UsersWithProfilesGridView:onCompositeCollectionRendered");
            },

            setGroupsColumnVisibility: function(groupColumnVisible){
                this.groupColumnVisible = groupColumnVisible;
                this._displayGroupsColumn();
                //currently there is no reason to go over the children view and call showGroupsColumn() they are recreated after collection is fetched/move to the groups tab
            },

            setUserTypeVisibility: function(userTypeVisibility) {
                this.userTypeColumnVisible = userTypeVisibility;
                this._displayUserTypeColumn();
            },

            setLobsColumnVisibility: function(lobsColumnVisibility) {
                this.lobsColumnVisible = lobsColumnVisibility;
                this._displayLobsColumn();
            },

            onClose: function(){
                LEUserManagement.logger.debug("onClose", "UsersWithProfilesGridView:onClose");
            },

            itemViewOptions: function(model, index) {
                return {
                    groupColumnVisible: this.groupColumnVisible,
                    userTypeColumnVisible: this.userTypeColumnVisible,
                    lobsColumnVisible: this.lobsColumnVisible,
                    gridModel: this.model
                };
            },

            updateCheckAll: function () {
                if (!this.checkAll) {
                    return;
                }

                var rows = this._getRowsOnPage();
                var hasRows = rows.length > 0;
                this.checkAll.setEnabled(hasRows);

                var selectionLength = this._getSelectedRowsOnPage().length;
                var rowsLength = rows.length;
                var checkedState;
                if (selectionLength === 0) {
                    checkedState = Checkbox.STATES.UNCHECKED;
                } else if (selectionLength === rowsLength) {
                    checkedState = Checkbox.STATES.CHECKED;
                } else if (selectionLength < rowsLength) {
                    checkedState = Checkbox.STATES.MIDCHECKED;
                }
                this.checkAll.setCheckedState(checkedState);
            },

            /*
            gets the child views on the current page, ignoring the empty-grid child view
             */
            _getRowsOnPage: function () {
                return this.children.filter(function(view) {
                    return view.model.id;
                });
            },

            _getSelectedRowsOnPage: function () {
                return _.filter(this.collection.getSelected(), function(selectedModel){
                    return !_.isEmpty(this.children.findByModel(selectedModel));
                }, this);
            },

            _createCheckAll: function () {
                if (!LEUserManagement.hasBatchUpdates()) {
                    return;
                }
                this.checkAll = new Checkbox({
                    checked: false,
                    label: '',
                    mode: Checkbox.MODES.TRISTATE,
                    permutation: Checkbox.PERMUTATION.B,
                    el: this.ui.selectAll
                });
                this.checkAll.render();
                this.listenTo(this.checkAll, Checkbox.TRIGGERING.CHANGE, this._onCheckAllChange.bind(this));
            },

            _onCheckAllChange: function (state) {
                // state will be an enum (string) as the checkbox is set to tristate,
                // we only care if it's checked or not, so turn it into a boolean representation
                state = this.checkAll.isChecked();
                this._checkAllItems(state);
            },

            _checkAllItems: function (state, silentCollection) {
                LEUserManagement.logger.debug("_checkAllItems", "UsersWithProfilesGridView:_checkAllItems");

                var command = state ? 'addToSelection' : 'deselectModel';
                this.children.each(function (itemView) {
                    this.selectableCollection[command](itemView.model, {silent: true});
                    itemView.model.trigger('model:selection:change', state);
                }.bind(this));

                if (!silentCollection) {
                    this.selectableCollection.triggerChange();
                }

                this.trigger('checkAll:change');
            },

            _displayGroupsColumn: function () {
                if (this.ui.groups.toggleClass){ //ui was initialized
                    this.ui.groups.toggleClass("hide", !this.groupColumnVisible);
                }
            },

            _displayUserTypeColumn: function () {
                if (this.ui.userType.toggleClass){ //ui was initialized
                    this.ui.userType.toggleClass("hide", !this.userTypeColumnVisible);
                }
            },

            _displayLobsColumn: function() {
                if (this.ui.lobs.toggleClass){ //ui was initialized
                    this.ui.lobs.toggleClass("hide", !this.lobsColumnVisible);
                }
            },

            _displayFootNote: function () {
                if (this.settingsCollection.isLastFetchReturnedSuccess()){
                    LEUserManagement.logger.debug("_onSettingsFetchSuccess", "UsersWithProfilesGridView:_onSettingsFetchSuccess");
                    this._showFootnoteView(true, this.settingsCollection);
                }else{
                    LEUserManagement.logger.debug("_onSettingsFetchError", "UsersWithProfilesGridView:_onSettingsFetchError");
                    this._hideFootnoteView();
                }
            },

            _showFootnoteView: function(footnoteState, settingsCollection) {
                LEUserManagement.logger.debug("showFootnoteView enter", "UsersWithProfilesGridView:showFootnoteView");
                if (this.uiComponents.footnote) {
                    this.uiComponents.footnote.updateSettings(settingsCollection);
                } else{
                    this.uiComponents.host$.createAndRender("footnote", {
                        type: UserListFootnoteView,
                        options:{
                            el: this.ui.footnoteContainer,
                            collection: settingsCollection
                        }
                    });
                }
                if (this.uiComponents.loader) {
                    this.uiComponents.loader.close();
                }
                this.ui.footnoteContainer.removeClass("hide");
                LEUserManagement.logger.debug("showFootnoteView exit", "UsersWithProfilesGridView:showFootnoteView");

            },

            _hideFootnoteView: function() {
                LEUserManagement.logger.debug("hideFootnoteView", "UsersWithProfilesGridView:hideFootnoteView");
                if (this.uiComponents.loader) {
                    this.uiComponents.loader.close();
                }
                this.ui.footnoteContainer.addClass("hide");
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UsersGridView;
});
